<template>
    <div>
        <div class="kqf-card  mg10 search-box mt20">
            <el-form :inline="true" :model="search" size="mini" class="demo-form-inline">
                <el-col :span="24">
                    <el-form-item label="流水单号：">
                        <el-input v-model="search.order_no" placeholder="请输入流水单号"></el-input>
                    </el-form-item>
                     <el-form-item label="关键字："  class="ml20">
                        <el-input v-model="search.keyword" placeholder="关键字" ></el-input>
                    </el-form-item>
                    <el-form-item label="套餐名称："  class="ml20">
                        <el-input v-model="search.title" placeholder="套餐名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="line-dashed  mb10"></div>
                </el-col>
                <el-form-item label="支付类型：">
                    <el-radio-group v-model="search.is_payment" @input="getList(1)">
                        <el-radio :label="-1">全部</el-radio>
                        <el-radio :label="0">未支付</el-radio>
                        <el-radio :label="1">已支付</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="系统：" class="ml20">
                    <el-select v-model="search.os_type" clearable placeholder="全部" style="width: 120px" @change="getList(1)">
                        <el-option label="安卓" value="android"></el-option>
                        <el-option label="苹果" value="ios"></el-option>
                        <el-option label="鸿蒙" value="harmony"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="支付方式：" class="ml20">
                    <el-select v-model="search.pay_type" clearable placeholder="全部" style="width: 120px" @change="getList(1)">
                        <el-option label="普通支付" value="normal"></el-option>
                        <el-option label="虚拟支付" value="virtual"></el-option>
                    </el-select>
                </el-form-item>
                    <el-form-item label="创建时间："  class="ml20">
                    <div class="block">
                        <el-date-picker
                                v-model="search.updated_at"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item class="ml20">
                        <el-button type="primary" @click="getList(1)">查询</el-button>
                        <el-button @click="refresh">重置</el-button>
                        <el-button @click="exportClick" type="success" plain>导出</el-button>
                </el-form-item>
                <el-form-item>
                    <div class="allMoney">总充值金额：<span class="num">{{datas.all_money}}</span></div>
                </el-form-item>
                <el-form-item>
                    <div class="allMoney">总赠送金额：<span class="num">{{datas.all_give_money}}</span></div>
                </el-form-item>
                <el-form-item>
                    <div class="allMoney">总合计充值：<span class="num">{{datas.sum_money}}</span></div>
                </el-form-item>
            </el-form>
        </div>
        <div class="kqf-card mg10 pd10 mt20" v-loading="loading" style="min-width: 1100px">
            <el-table border :data="datas.list"   height="calc(100vh - 330px)">
                <el-table-column label="ID" width="80" prop="order_id"></el-table-column>
                <el-table-column label="用户信息" width="250">
                    <template slot-scope="scope">
                        <div class="flex">
                            <el-avatar :size="40" :src="scope.row.face"></el-avatar>
                            <div style="margin-left:10px ">
                                <p class="text-over">{{ scope.row.nickname }}</p>
                                <el-link v-clipboard:success="copySuccess" v-clipboard:copy="scope.row.mobile" type="primary"
                                         :underline="false">{{ scope.row.mobile }}
                                </el-link>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="流水单号" width="210" prop="order_no" align="center"></el-table-column>
                <el-table-column label="充值套餐ID" width="120" prop="package_id" align="center"></el-table-column>
                <el-table-column label="套餐名称" prop="title" align="center"></el-table-column>
                <el-table-column label="充值渠道" width="140" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.pay_channel_label || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值金额" width="150" prop="money" align="center"></el-table-column>
                <el-table-column label="赠送金额" width="150" prop="give_money" align="center"></el-table-column>
                <el-table-column label="支付类型" width="150" align='center'>
                    <template  slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.is_payment==0">未支付</el-tag>
                        <el-tag type="danger" v-if="scope.row.is_payment==1">已支付</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="总合计充值" width="100" prop="sum_money" align="center"></el-table-column>
                <el-table-column label="创建时间" width="200" prop="created_at"></el-table-column>
                <el-table-column label="更新时间" width="200" prop="updated_at"></el-table-column>
            </el-table>
            <div class="flex center mt10">

                <div>
                    <el-pagination
                            @current-change="getList"
                            background
                            :page-size="datas.limit"
                            layout="total, prev, pager, next"
                            :total="datas.count">
                    </el-pagination>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {getRechargeOrder} from "../../request/api/rechargeRecord/rechargeRecord";
    import XLSX from 'xlsx'
    export default {

        data(){
            return{
                datas: [],
                search: this.getSearch(),
                //编辑信息
                editloading:false,
                editdialog:false,
                editdata:{
                    keyword:'',
                    remarks:'',
                    entry_type:-1,
                    type:-1,
                    entry_id:"",
                    created_at:"",
                },
                loading: false,
                pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            }
        },
        created() {
            this.getList();
        },
        methods:{
            getSearch() {
                return {
                    keyword:'',
                    title:'',
                    is_payment:-1,
                    os_type:'',
                    pay_type:'',
                    updated_at:"",
                    order_no:'',
                    page: 1,
                }
            },
            getList(page) {
                this.search.page = page;
                this.loading = true;
                getRechargeOrder({
                    keyword:this.search.keyword,
                    title:this.search.title,
                    is_payment:this.search.is_payment,
                    os_type:this.search.os_type,
                    pay_type:this.search.pay_type,
                    updated_at:this.search.updated_at,
                    order_no:this.search.order_no,
                    page: page,
                }).then(res => {
                    this.datas = res;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            refresh() {
                this.search = this.getSearch();
                this.getList(1);
            },
            // 复制
            copySuccess() {
                this.$message.success("复制成功");
            },
            // 导出
            exportClick(){
                this.loading = true;
                getRechargeOrder({
                    keyword:this.search.keyword,
                    title:this.search.title,
                    is_payment:this.search.is_payment,
                    os_type:this.search.os_type,
                    pay_type:this.search.pay_type,
                    updated_at:this.search.updated_at,
                    order_no:this.search.order_no,
                    page:1,
                    is_excel:1
                }).then(res => {
                    this.loading = false;
                    let excelDataAll = [
                        ['ID','姓名','手机号','流水单号','充值套餐ID','套餐名称','充值渠道','充值金额','赠送金额','支付状态','总合计充值','创建时间','更新时间'],
                    ]
                    let excelData = []
                    res.list.forEach((item)=>{
                        excelData.push(item.order_id)
                        excelData.push(item.nickname)
                        excelData.push(item.mobile)
                        excelData.push(item.order_no)
                        excelData.push(item.package_id)
                        excelData.push(item.title)
                        excelData.push(item.pay_channel_label || '-')
                        excelData.push(item.money)
                        excelData.push(item.give_money)
                        excelData.push(item.is_payment == 1 ? '已支付' : '未支付' )
                        excelData.push(item.sum_money)
                        excelData.push(item.created_at)
                        excelData.push(item.updated_at)
                        excelDataAll.push(excelData)
                        excelData = []
                    })
                    console.log('aaa=>',excelDataAll)
                    const ws = XLSX.utils.aoa_to_sheet(excelDataAll)
                    const wb = XLSX.utils.book_new()
                    XLSX.utils.book_append_sheet(wb,ws,'Sheet1')
                    XLSX.writeFile(wb,'充值记录.xlsx')
                }).catch(() => {
                    this.loading = false;
                });
            }
        },
    }
</script>
<style scoped>
    .allMoney {
        margin-left: 20px;
    }
    .allMoney .num {
        font-size: 15px;
        color: #ff5646;
    }
</style>
